import { ENV_COUNTRY } from 'sysconfig';
import {
  GIFT_IMAGE_DEFAULT_CACHED,
  LOGO_BUYMED_GG,
  NEW_MISSING_IMAGE_CACHED,
  STORE_IMAGE_DEFAULT_CACHED,
} from './default';

// slider
// export const URL_SLIDER_1 = '/images/media/logo_tccs.png'; // deprecated 22Feb2023 - Dinh Tran
export const URL_SLIDER_2 = '/images/partner/logo_domesco.jpg';
export const URL_SLIDER_3 = '/images/partner/logo_gsk.jpg';
export const URL_SLIDER_4 = '/images/partner/logo_imex.jpg';
export const URL_SLIDER_5 = '/images/partner/logo_mp.jpg';
export const URL_SLIDER_6 = '/images/partner/logo_nic.jpg';
export const URL_SLIDER_7 = '/images/partner/logo_pharmedic.jpg';
export const URL_SLIDER_8 = '/images/partner/logo_sanofi_8-8-2022.png';
export const URL_SLIDER_9 = '/images/partner/logo_stada.jpg';
export const URL_SLIDER_10 = '/images/partner/logo_usp.jpg';
export const URL_SLIDER_11 = '/images/partner/logo_vpc.jpg';
export const URL_SLIDER_12 = '/images/partner/logo_davipharm.png';

// image media
export const URL_LOGO_SEEDSTAR = '/images/media/logo_seedstar.png';
// export const URL_LOGO_TCCS = '/images/media/logo_tccs.png'; // deprecated 22Feb2023 - Dinh Tran
// export const URL_LOGO_PITCHPALACE = '/images/media/logo_pitchpalace.png'; // deprecated 22Feb2023 - Dinh Tran
export const URL_LOGO_NTTDATA = '/images/media/logo_nttdata.png';
export const URL_LOGO_ECHELON = '/images/media/logo_echelon.png';
// export const URL_LOGO_INVESTGLOBAL = '/images/media/logo_investglobal.png'; // deprecated 22Feb2023 - Dinh Tran
// export const URL_LOGO_FORBES = '/images/media/logo_forbes.png'; // deprecated 22Feb2023 - Dinh Tran
export const URL_LOGO_E27 = '/images/media/logo_e27.png';

// import media 16Aug2022
export const URL_LOGO_24H = '/images/media/logo_24h.jpg';
export const URL_LOGO_BAOTIENPHONG = '/images/media/logo_baotienphong.jpg';
export const URL_LOGO_CAFEBIZ = '/images/media/logo_cafebiz.png';
export const URL_LOGO_VNEXPRESS = '/images/media/logo_vnexpress.jpg';

const MAP_BRAND_LOGO = {
  vn: '/images/logo/brand-logo.svg',
  cam: '/static/images/buymed.svg',
  en: '/static/images/buymed.svg',
  th: '/static/images/buymed.svg',
};

const MAP_BRAND_LOGO_WHITE = {
  vn: '/images/logo/brand-logo.svg',
  cam: '/static/images/buymed_white.svg',
  en: '/static/images/buymed_white.svg',
  th: '/static/images/buymed_white.svg',
};

export const BRAND_LOGO_SVG = MAP_BRAND_LOGO[`${ENV_COUNTRY}`] || '/images/logo/brand-logo.svg';
export const BRAND_LOGO_WHITE_SVG =
  MAP_BRAND_LOGO_WHITE[`${ENV_COUNTRY}`] || '/images/logo/brand-logo.svg';
export const BRAND_LOGO_NEW_SVG = '/images/logo/brand-logo-new.svg';

export const LOGO_FOOTER_CONTACT = '/static/images/footer/contact.svg';
export const LOGO_FOOTER_LOCATION = '/static/images/footer/location.svg';
export const LOGO_3_TOT = '/icons/3_tot.png';

export const SANPHAMMOI_ICON = '/icons/sanphammoi.png';
// export const LIKE_ICON = '/icons/like.png'; // deprecated 22Feb2023 - Dinh Tran
export const DOUBLE_ARROW_ICON = '/icons/double_arrow.svg';
export const LIKE_ICON_GREEN = '/icons/like_green.png';
export const DEALS_ICON = '/icons/deals.png';
export const TICKET_PROMO_ICON = '/icons/ticket_promo.svg';
export const TICKET_ICON = '/icons/ticket_icon.svg';
export const TICKET_ICON_MOBILE = '/icons/ticket_icon_mobile.svg';

// export const ROSE_ICON = '/icons/rose_icon.svg'; // deprecated 22Feb2023 - Dinh Tran
export const PRODUCT_ICON = '/icons/product_icon.png';
export const ADD_FILE_ICON = '/images/icon/add_file.png';

export const KG_ICON = '/images/icon/kg.svg';
export const KG_ICON_V2 = '/images/icon/kg_v2.svg';
// export const TROLLEY_ICON = '/images/icon/trolley.svg'; // deprecated 22Feb2023 - Dinh Tran
// export const VIEW_ICON = '/images/icon/view.svg'; // deprecated 22Feb2023 - Dinh Tran
// export const PERSON_ICON = '/icons/person.png'; // deprecated 22Feb2023 - Dinh Tran
// export const PACKAGE_ICON = '/icons/package.png'; // deprecated 22Feb2023 - Dinh Tran
// export const CART_ICON = '/images/icon/cart_icon.png';
export const EYE_ICON = '/images/icon/eye.svg';
export const SHOPPING_CART_ICON = '/images/icon/shopping-cart.svg';

// export const WISHLIST_ICON_1 = I_WISHLIST_ICON_1;
// export const WISHLIST_ICON_2 = I_WISHLIST_ICON_2;
// export const WISHLIST_ICON_3 = I_WISHLIST_ICON_3;
// export const WISHLIST_ICON_4 = I_WISHLIST_ICON_4;

export const WISHLIST_ICON_1 = '/icons/wishlist_icon_1.svg';
// export const WISHLIST_ICON_2 = '/icons/wishlist_icon_2.svg';
// export const WISHLIST_ICON_3 = '/icons/wishlist_icon_3.svg';
export const WISHLIST_ICON_4 = '/icons/wishlist_icon_4.svg';

// OTHER
export const LOGO_THUOCSI = '/logo_ts.png';
export const LOGO_THUOCSI_SHORTENED = '/thuocsi_short.svg';
// export const FAVICON_DEFAULT = '/images/favicon.ico';
// export const MISSING_IMAGE = DEFAULT_MISSING_IMAGE;
export const MISSING_IMAGE = NEW_MISSING_IMAGE_CACHED;
export const GIFT_IMAGE = GIFT_IMAGE_DEFAULT_CACHED;
export const LOGO_NOT_MATCH_CONDITIONS = '/images/chua_thoa_dk.svg';
export const GIFT_ICON = '/images/gift.svg';
export const STORE_ICON = '/images/deals/store.svg';
// export const FAST_DELIVERY_ICON = '/images/deals/fast-delivery.svg';
export const MOBILE_STORE_ICON = '/images/deals/mobile_store.svg';

// Khuyen mai
export const MEGA_SALE_ICON = '/images/deals/mega_sale.svg';
export const FLASH_SALE_ICON = '/images/deals/flash_sale.svg';

// FOOTER_V2
export const CALL_ICON = '/images/footer-v2/Contact/call.svg';
// export const FB_ICON = '/images/footer-v2/Contact/fbicon.svg';
export const SUPPORT_ICON = '/images/footer-v2/Contact/support.svg';
export const APPSTORE = '/images/footer-v2/Download/appstore.svg';
export const URL_APPSTORE = '/images/footer-v2/Download/appstore.svg';
export const GOOGLEPLAY = '/images/footer-v2/Download/googleplay.svg';
export const AHAMOVE = '/images/footer-v2/ShipService/ahamove.png';
export const GHN = '/images/footer-v2/ShipService/ghn.png';
export const GHTK = '/images/footer-v2/ShipService/ghtk.png';
export const GRAB = '/images/footer-v2/ShipService/grab.png';
export const NINJAVAN = '/images/footer-v2/ShipService/ninjavan.png';
export const VIETTELPOST = '/images/footer-v2/ShipService/viettelpost.png';
export const PHONEFRAME = '/images/footer-v2/phoneFrame.svg';
export const FACEBOOK_ICON = '/images/footer-v2/Connect/facebook_icon.svg';
export const LINKED_ICON = '/images/footer-v2/Connect/linked_icon.svg';
export const TIKTOK_ICON = '/images/footer-v2/Connect/tiktok_icon.svg';
export const ZALO_ICON = '/images/footer-v2/Connect/zalo_icon.svg';
// export const LICENSE = '/images/footer-v2/license.png';

export const URL_LICENSE = '/images/footer/logo_register.png';
// export const URL_LICENSE_TRANSPARENT = '/images/footer-v2/license.png';

// slider
// export const SLIDER_1 = I_SLIDER_1;
// export const SLIDER_2 = I_SLIDER_2;
// export const SLIDER_3 = I_SLIDER_3;
// export const SLIDER_4 = I_SLIDER_4;
// export const SLIDER_5 = I_SLIDER_5;
// export const SLIDER_6 = I_SLIDER_6;
// export const SLIDER_7 = I_SLIDER_7;
// export const SLIDER_8 = I_SLIDER_8;
// export const SLIDER_9 = I_SLIDER_9;
// export const SLIDER_10 = I_SLIDER_10;
// export const SLIDER_11 = I_SLIDER_11;

// end slider

export const NOTICEV2_ICON = '/images/header-v2/Notice_icon.svg';
export const AVATARV2_ICON_IMAGE = '/images/header-v2/UserAvatar_icon.svg';
export const AVATARV2_ICON = '/images/header-v2/UserAvatar_icon.svg';
export const NEWSV2_ICON = '/images/header-v2/New_icon.svg';
export const CAREERV2_ICON = '/images/header-v2/Career_icon.svg';
export const HOMEV2_ICON = '/images/header-v2/Home_icon.svg';

export const SEARCHV2_ICON = '/images/header-v2/Search_icon.svg';
export const SEARCHV2ACTIVE_ICON = '/images/header-v2/SearchActive_icon.svg';

// FOOTER
export const LOGO_FOOTER_SVG = '/images/footer/logo_footer.svg';
// export const LOGO_FOOTER_NEW_PNG = '/images/logo_thuocsi_new.png';
export const LOGO_FOOTER_REGISTER = '/images/footer/logo_register2.png';

export const LOGO_GHTK = '/images/footer/logo_ghtk.png';
export const LOGO_AHAMOVE = '/images/footer/logo_ahamove.png';
export const LOGO_GRAB = '/images/footer/logo_grab.png';
export const LOGO_GHN = '/images/footer/logo_ghn.png';
export const LOGO_LOZA = '/images/footer/logo_loza.png';
export const LOGO_NINJA = '/images/footer/logo_ninja.png';
export const LOGO_MOBILE = '/images/footer/img_mobileapp.png';
export const LOGO_GOOGLEPLAY = '/images/footer/logo_googleplay.png';
export const LOGO_APPSTORE = '/images/footer/logo_appstore.png';
export const LOGO_APPSTORE_NEW = '/images/footer/logo_appstore_new.png';
export const LOGO_FACEBOOK_NEW = '/images/footer/logo_fb_new.png';
export const LOGO_GOOGLEPLAY_NEW = '/images/footer/logo_chplay_new.png';

export const LINK_REGISTER = 'http://online.gov.vn/Home/WebDetails/52192';
export const LINK_APPLESTORE = 'https://apps.apple.com/us/app/buymed-thailand/id6450183967';
export const DOMAIN_GOOGLE_PLAY = 'https://play.google.com';
export const LINK_GOOGLEPLAY = `${DOMAIN_GOOGLE_PLAY}/store/apps/details?id=com.buymed.app.th`;
export const DOMAIN_STORAGE = 'https://buymed-storage.s3-ap-southeast-1.amazonaws.com';
export const LINK_DOWNLOAD_AUTO_DETECT = 'https://buymed.co.th/app';
// export const LINK_LICENSE = `${DOMAIN_STORAGE}/trading_license/1.+Trading+License+-+Buymed+(GC+20+June+2019)+(VN).pdf`;

// promotion

// New version 2

// export const CARTV2_ICON = '/images/header-v2/Cart_icon.svg';
export const CARTV2_ICON = '/images/header-v2/Cartv2_icon.svg';
export const DELETEV2_ICON = '/images/iconV2/deleteIcon.svg';
// Level Icon
export const DIAMOND_ICON = '/images/icons/diamond.svg';
export const GOLD_ICON = '/images/icons/gold.svg';
export const PLATINUM_ICON = '/images/icons/platinum.svg';
export const SILVER_ICON = '/images/icons/silver.svg';

// export const GIFT_IMAGE =
//   'https://assets.thuocsi.vn/assets/defaults/qua_tang-d6b9623d40a9924ac56d42815f5ed983f93ef06a88ec91c36261bb3bbb222553.jpg';
export const LOGO_PHARMACY = '/images/default/pharmacy.svg';

// seller
// export const BADGE_SELLER = '/images/default/badge.png';
export const STORE_IMAGE_DEFAULT = STORE_IMAGE_DEFAULT_CACHED;

// productV2

// export const TAGNEWPRODUCT = '/images/iconV2/tagNew_product.svg';
// export const DEFAULTPRODUCT = '/images/iconV2/defaultProduct.svg';

// feedback product detail
export const FEEDBACKSTATUS_ICON = '/images/feedbackDetail/statusFeedback.svg';
export const FEEDBACKTS_LOGO = '/images/feedbackDetail/logoThuocsi.png';
export const FEEDBACKUSER_ICON = '/images/feedbackDetail/userFeedback.png';
export const PHAN_HOI_ICON = '/images/icon_phan_hoi.svg';
// qr code
// export const DEFAULT_PRODUCT_ICON = '/images/default/defaultPicture.png';
// export const QUICK_ORDER_ICON = '/images/qrCode/quickOrder.svg';
// export const QUICK_BILL_ICON = '/images/qrCode/quickBill.svg';
// export const FREESHIP_ICON = '/images/qrCode/freeShip.svg';

// export const VONG_QUAY_ICON = '/images/deals/vong_quay_3.svg';
// export const MOTORBIKE_ICON = '/images/deals/motorbike.svg';

// infoTabsV2
export const USER_ICON = '/images/infoTabsV2/user.svg';
export const USER_ICON_ACTIVE = '/images/infoTabsV2/userActive.svg';
export const BILL_ICON = '/images/infoTabsV2/billoflading.svg';
export const BILL_ICON_ACTIVE = '/images/infoTabsV2/billofladingActive.svg';
export const FEEDBACK_ICON = '/images/infoTabsV2/feedback.svg';
export const FEEDBACK_ICON_ACTIVE = '/images/infoTabsV2/feedBackActive.svg';

export const ORDER_ICON_MENU = '/images/infoTabsV2/myOrder.svg';
export const ORDER_ICON_MENU_ACTIVE = '/images/infoTabsV2/myOrderActive.svg';

export const POINTS_ICON = '/images/infoTabsV2/points.svg';
export const POINTS_ICON_ACTIVE = '/images/infoTabsV2/pointsActive.svg';
export const REFER_FRIEND_ICON = '/images/infoTabsV2/referFriends.svg';
export const REFER_FRIEND_ICON_ACTIVE = '/images/infoTabsV2/referFriendsActive.svg';
export const STATISTICAL_ICON = '/images/infoTabsV2/statistical.svg';
export const STATISTICAL_ICON_ACTIVE = '/images/infoTabsV2/statisticalActive.svg';

export const WISHLIST_ICON = '/images/infoTabsV2/wishlist.svg';
export const WISHLIST_ICON_ACTIVE = '/images/infoTabsV2/wishlistActive.svg';

export const VIEWED_ICON = '/images/infoTabsV2/viewed.svg';
export const VIEWED_ICON_ACTIVE = '/images/infoTabsV2/viewedActive.svg';

export const QR_ICON = '/images/infoTabsV2/qr.svg';
export const QR_ICON_ACTIVE = '/images/infoTabsV2/qrActive.svg';

export const QUEST_REWARDS_ICON = '/images/infoTabsV2/quest_rewards.svg';
export const QUEST_REWARDS_ICON_WHITE = '/images/infoTabsV2/quest_reward_white.svg';
export const QUEST_REWARDS_ICON_ACTIVE = '/images/infoTabsV2/quest_rewards_active.svg';
export const LEVEL_ICON = '/images/infoTabsV2/level_icon.svg';
export const LEVEL_ICON_ACTIVE = '/images/infoTabsV2/level_icon_active.svg';
export const VOUCHER_ICON = '/images/infoTabsV2/voucher_icon.svg';
export const VOUCHER_ICON_ACTIVE = '/images/infoTabsV2/voucher_icon_active.svg';

export const LOGOUT_ICON = '/images/infoTabsV2/logout.svg';

export const USER_ICON_WHITE = '/images/infoTabsV2/account_white.svg';
export const TRUCK_ICON_WHITE = '/images/infoTabsV2/truck_white.svg';
export const FEEDBACK_ICON_WHITE = '/images/infoTabsV2/feedback_white.svg';
export const ORDER_ICON_MENU_WHITE = '/images/infoTabsV2/order_white.svg';
export const POINTS_ICON_WHITE = '/images/infoTabsV2/point_white.svg';
export const REFER_FRIEND_ICON_WHITE = '/images/infoTabsV2/refer_white.svg';
export const STATISTICAL_ICON_WHITE = '/images/infoTabsV2/static_white.svg';
export const WISHLIST_ICON_WHITE = '/images/infoTabsV2/heart_white.svg';
export const VIEWED_ICON_WHITE = '/images/infoTabsV2/viewed_white.svg';
export const QR_ICON_WHITE = '/images/infoTabsV2/qr_white.svg';
export const LEVEL_ICON_WHITE = '/images/infoTabsV2/level_white.svg';
export const VOUCHER_ICON_WHITE = '/images/infoTabsV2/voucher_white.svg';
export const LOGOUT_ICON_WHITE = '/images/infoTabsV2/logout_white.svg';

// export const FILE_NEW_PRODUCT = '/static/files/newproduct.pdf';
// export const FILE_NEW_PRODUCT = '/static/files/sanphammoi.pdf';
// export const TRUCK_ICON_WHITE = '/images/infoTabsV2/truck_white.svg';

// export const FILE_NEW_PRODUCT_MIEN_BAC = '/static/files/sanphammoi_mienbac.pdf';
// export const FILE_NEW_PRODUCT_MIEN_NAM = '/static/files/sanphammoi_miennam.pdf';

// export const FILE_ALTERNATIVE_PRODUCT_MIEN_BAC = '/static/files/san_pham_thay_the_mien_bac.pdf';
// export const FILE_ALTERNATIVE_PRODUCT_MIEN_NAM = '/static/files/san_pham_thay_the_mien_nam.pdf';

// /myOrder icon
export const ReturnOrderIcon = '/icons/ReturnOrderIcon.svg';
// block account
export const BLOCK_ACCOUNT = '/images/block_account.png';
export const MAIL_ICON = '/images/mail.png';

// logoV2
export const NEW_LOGO = ENV_COUNTRY === 'vn' ? '/images/logoV2.svg' : LOGO_BUYMED_GG;
export const URL_NEW_LOGO = ENV_COUNTRY === 'vn' ? '/images/logoV2.svg' : LOGO_BUYMED_GG;

//
export const DELIVERY_FROM = '/images/shipping-policy/delivery-form.png';
export const DELIVERY_APOLOGIZE = '/images/shipping-policy/apologize-delivery.png';

// 404
export const IMAGE_404 = '/assets/404/404.svg';
export const LOGO_THUOCSI_404 =
  ENV_COUNTRY === 'vn' ? '/assets/404/newLogoThuocsi.svg' : LOGO_BUYMED_GG;
export const ICON_404_MAIL = '/assets/404/mail.svg';
export const ICON_404_PHONE = '/assets/404/phone.svg';
// loyalty v2
export const VOUCHER_TITLE_DETAIL = '/images/loyaltyv2/giftPromotion.svg';
export const VOUCHER_TITLE = '/images/loyaltyv2/voucherTS.svg';
// export const VOUCHER_TS_IMG = '/images/loyaltyv2/voucherThuocsi_img.svg';
// export const VOUCHER_FRAME = '/images/loyaltyv2/voucherFrame.svg';
export const LOYALTY_ARROW_VIEW_MORE = '/images/loyaltyv2/loyalty_arrow_bottom.svg';
// export const VOUCHER_TS_MIN = '/images/loyaltyv2/voucherTS_min.svg';
export const VOUCHER_TS_MIN = '/images/loyaltyv2/voucherNew.svg';
export const VOUCHER_FRAME_MIN = '/images/loyaltyv2/voucher_frame_min.svg';
export const TimeOrderStatus = '/orderStatus/time.svg';
// export const ICON_VAT_ORDER = '/orderStatus/iconVAT.svg';
// export const ICON_EXPORT_XLS_ORDER = '/orderStatus/iconExportXLS.svg';
export const ICON_FEEDBACK_ORDER = '/orderStatus/iconFeedback.svg';
export const ICON_ARROW_ORDER = '/orderStatus/arrowOrder.svg';
export const ICON_ARROW_ORDER_ACTIVE = '/orderStatus/arrowOder_active.svg';
export const VOUCHER_TITLE_GREEN = '/images/loyaltyv2/voucherTSgreen.svg';
export const VOUHCER_PROMOTION_BOX = '/images/loyaltyv2/giftBox.svg';
// orderdetail v2
export const ReAddToCartV2 = '/images/detailOrderV2/addtocartV2.svg';
export const EditDetailV2 = '/images/detailOrderV2/editOrderV2.svg';
export const I_WAIT_TO_CONFIRM = '/images/detailOrderV2/wait_to_confirm.svg';
// export const I_PROCESSING = '/images/detailOrderV2/wait_to_confirm.svg';
export const I_DELIVERING = '/images/detailOrderV2/delivering.svg';
export const I_DELIVERED = '/images/detailOrderV2/delivered.svg';
export const I_TRANSPORTING = '/images/detailOrderV2/transporting.svg';
export const I_FILE_CHECKED = '/images/detailOrderV2/file_checked.svg';
export const I_EDIT_ORDER_V2 = '/images/detailOrderV2/edit_order_v2.svg';
export const I_PROCESSING_V2 = '/images/detailOrderV2/processing.svg';

export const I_CONFIRMED = '/images/detailOrderV2/confirmed.svg';
export const I_COMPLETED = '/images/detailOrderV2/completed.svg';
export const I_EXIT = '/images/detailOrderV2/exit.svg';
export const I_FEEDBACK_DETAILV2 = '/images/detailOrderV2/feedbackOrderV2.svg';
export const I_RETURN_ORDER_DETAILV2 = '/images/detailOrderV2/returnOrderV2.svg';
export const I_ARROW_RIGHT_DETAILV2 = '/images/detailOrderV2/arrowRight.svg';
export const EDIT_INVOICE = '/images/detailOrderV2/editInvoice.svg';
export const UP_INVOICE = '/images/detailOrderV2/iconUP.svg';
// loyalty v2
export const SLIVER_ICON_RANK = '/images/loyalty-v2/loyalty_rank_sliver.svg';
export const GOLD_ICON_RANK = '/images/loyalty-v2/loyalty_gold_rank.svg';
export const PLATINUM_ICON_RANK = '/images/loyalty-v2/loyalty_rank_platinum.svg';
export const DIAMOND_ICON_RANK = '/images/loyalty-v2/loyalty_diamond_rank.svg';

export const SLIVER_ICON_RANK_ACTIVE = '/images/loyalty-v2/rank_sliver_active.svg';
export const DIAMOND_ICON_RANK_ACTIVE = '/images/loyalty-v2/rank_diamond_active.svg';
export const PLATINUM_ICON_RANK_ACTIVE = '/images/loyalty-v2/rank_platinum_active.svg';
export const GOLD_ICON_RANK_ACTIVE = '/images/loyalty-v2/rank_gold_active.svg';
export const SECTION_STORE_ICON = '/images/pill.png';

export const AMBASSADOR_ICON_RANK_ACTIVE = '/images/loyalty-v2/loyalty_ambassador_rank_active.svg';
export const AMBASSADOR_ICON_RANK = '/images/loyalty-v2/loyalty_ambassador_rank.svg';

// cart -> popup promo
export const VOUCHER_TS_PROMO = '/images/logoV2.svg';
export const CART_VOUCHER_CHECKED_ICON = `/images/cart/checked_icon.svg`;
export const CART_VOUCHER_CHECKBOX_ICON = `/images/cart/checkbox_icon.svg`;
export const CART_NEW_GIFT_ICON = `/images/cart/gift_icon.svg`;

// mobile layout
export const MOBILE_ICON_ALERT_SUCCESS = '/images/mobile/alert/success.svg';
export const MOBILE_ICON_RATING_STAR = '/icons/mobile/conversations/rating_star.svg';
export const MOBILE_ICON_RATING_STAR_FILL = '/icons/mobile/conversations/rating_star_fill.svg';
export const MOBILE_ICON_RATING_STAR_NOT_FILL =
  '/icons/mobile/conversations/rating_star_not_fill.svg';
export const MOBILE_ICON_RATING_SUCCESS = '/icons/mobile/conversations/rating_success.svg';
export const MOBILE_ICON_ATTACH_FILE = '/icons/mobile/conversations/icon_attach_file.svg';
// detail product
export const SAME_STORE = '/icons/mobile/detail-product/same_store.svg';
export const SAME_INGREDIENT = '/icons/mobile/detail-product/same_ingredient.svg';
// wishlist v2
export const I_WISHLIST_DEL = '/icons/wishlist_del_icon.svg';
export const DELETE_VOUCHER_ICON = '/images/delete_voucher.svg';
export const GIFT_ICON2 = '/images/gift_icon.svg';

// hardcode tab
export const HANG_DIEM_ICON = '/icons/hang_diem.png';

// new gift
export const GIFT_NEW_GREEN = '/images/gift_icon.svg';

// thankyou page
export const ORDER_SUCCESS_THANKYOU = '/images/thankyou/order_success.svg';
export const CAMBODIAN_ORDER_SUCCESS_THANKYOU = '/images/thankyou/cam_order_success.svg';
export const THAI_ORDER_SUCCESS_THANKYOU = '/images/thankyou/thai_order_success.svg';

export const ORDER_SUCCESS_THANKYOU_MAP = {
  vn: ORDER_SUCCESS_THANKYOU,
  en: CAMBODIAN_ORDER_SUCCESS_THANKYOU,
  cam: CAMBODIAN_ORDER_SUCCESS_THANKYOU,
  th: THAI_ORDER_SUCCESS_THANKYOU,
};

export const ICON_KHUNG_LONG = '/icons/khunglong.svg';

export const HOME_BG_MEGA_SALE = '/images/mega-sale-bacground.svg';
export const HOME_ICON_MEGA_SALE = '/icons/mega-sale.svg';

// toggle profile
export const PROFILE_CHANGE_LANGUAGE = '/images/profile-toggle/change_language.svg';
export const PROFILE_ENGLISH = '/images/profile-toggle/english.svg';
export const PROFILE_THAI = '/images/profile-toggle/thailand.svg';

// media
export const MEDIA_TH_1 = 'th/web/Tech-in-Asia.png';
export const MEDIA_TH_2 = 'th/web/Naewna.png';
export const MEDIA_TH_3 = 'th/web/Youtube.png';
export const MEDIA_TH_4 = 'th/web/Kapook.png';
export const MEDIA_TH_5 = 'th/web/Sanook.png';
export const MEDIA_TH_6 = 'th/web/MThai.png';
export const MEDIA_TH_7 = 'th/web/Newswit.png';
export const MEDIA_TH_8 = 'th/web/Press.in.th.png';
export const MEDIA_TH_9 = 'th/web/Thailand4.png';
export const MEDIA_TH_10 = 'th/web/RYT9.png';
export const MEDIA_TH_11 = 'th/web/ThaiPR.png';

export const MEDIA_TH_M_1 = 'th/mobile/Tech-in-Asia_m.png';
export const MEDIA_TH_M_2 = 'th/mobile/Naewna_m.png';
export const MEDIA_TH_M_3 = 'th/mobile/Youtube_m.png';
export const MEDIA_TH_M_4 = 'th/mobile/Kapook_m.png';
export const MEDIA_TH_M_5 = 'th/mobile/Sanook_m.png';
export const MEDIA_TH_M_6 = 'th/mobile/MThai_m.png';
export const MEDIA_TH_M_7 = 'th/mobile/Newswit_m.png';
export const MEDIA_TH_M_8 = 'th/mobile/Press.in.th_m.png';
export const MEDIA_TH_M_9 = 'th/mobile/Thailand4_m.png';
export const MEDIA_TH_M_10 = 'th/mobile/RYT9_m.png';
export const MEDIA_TH_M_11 = 'th/mobile/ThaiPR_m.png';

// banner
export const MEDIA_VIDEO_TH_1 = '/static/images/homepage/videos/review01.png';
export const MEDIA_VIDEO_TH_2 = '/static/images/homepage/videos/review02.png';
export const MEDIA_VIDEO_TH_3 = '/static/images/homepage/videos/review03.png';
export const MEDIA_VIDEO_TH_4 = '/static/images/homepage/videos/review04.png';
export const MEDIA_VIDEO_TH_5 = '/static/images/homepage/videos/review05.png';

// lucky wheel
export const LUCKYWHEEL_BORDER = `/images/spinner/wheel_without_center.svg`;
export const LUCKYWHEEL_BORDER_WITH_CENTER = `/images/spiner/wheel_with_center.svg`;
export const LUCKYWHEEL_CENTER = `   /images/spinner/wheel_center.svg`;
export const LUCKYWHEEL_ARROW_SELECTOR = `/images/spinner/selector.svg`;
export const LUCKYWHEEL_TOP_SPIN_BUTTON = `/images/spinner/top_button_spin.svg`;
export const LUCKYWHEEL_BOTTOM_SPIN_BUTTON = `/images/spinner/bottom_button_spin.svg`;
export const LUCKWHEEL_ICON_WARNING = `/images/spinner/icon_popup_warning.svg`;
export const LUCKYWHEEL_BACKGROUND = `/images/spinner/spinner_bg.png`;
export const LUCKYWHEEL_MOBILE_BACKGROUND = `/images/spinner/mobile_spinner_bg.png`;

export const LUCKYWHEEL_TIME_ICON = `   /images/spinner/time_icon.svg`;
export const LUCKYWHEEL_GUILDLINE_ICON = `/images/spinner/guildline_icon.svg`;
export const LUCKYWHEEL_TITLE = `/images/spinner/wheel_title.png`;
export const LUCKYWHEEL_MOBILE_MISSION_ICON = `/images/spinner/mission_shadow_icon.svg`;
export const LUCKYWHEEL_MOBILE_GUILDLINE_ICON = `/images/spinner/guildline_shadow_icon.svg`;
export const LUCKYWHEEL_MOBILE_HISTORY_ICON = `/images/spinner/history_shadow_icon.svg`;
export const LUCKYWHEEL_MOBILE_TAB_BACKGROUND = `/images/spinner/mobile_tab_background.svg`;
export const LUCKYWHEEL_MOBILE_CLOSE_BUTTON = `/images/spinner/mobile_close_button.svg`;
export const LUCKYWHEEL_MOBILE_PRIZE_BG = `/images/spinner/mobile_popup_prize_bg.svg`;
export const LUCKYWHEEL_MISSION_ICON = `/images/spinner/mission_icon.svg`;
export const LUCKYWHEEL_MOBILE_POPUP_MISSION_BG = `/images/spinner/mobile_popup_mission_bg.png`;
export const LUCKYWHEEL_MOBILE_OOT_TEXT = `/images/spinner/mobile_oot.png`;
export const LUCKYWHEEL_MOBILE_SPIN_TEXT = `/images/spinner/mobile_spin_text.png`;
export const LUCKYWHEEL_BLOCKED_ICON = `/images/spinner/blocked_icon.svg`;
export const LUCKYWHEEL_DEFAULT_BACKGROUND = `/images/spinner/spinner_bg.png`;
export const LUCKYWHEEL_SHARE_ICON = `/images/spinner/popup_share_icon.png`;
export const LUCKYWHEEL_SHARE_FACEBOOK_ICON = `/images/spinner/facebook_icon.svg`;
export const LUCKYWHEEL_SHARE_ZALO_ICON = `/images/spinner/zalo_mobile_icon.svg`;
export const LUCKYWHEEL_WEBVIEW_BACKGROUND = `/images/spinner/mobile_spinner_bg.png`;
